import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";
import { isEmpty } from "lodash-es";
import { useEffect, useRef } from "react";

import { useIsModal } from "@/components/General/Modal/context/modal.context";
import { StoreCardSkeleton } from "@/components/Store/StoreSearch/components/list/storeCard/storeCard.skeleton";

import { useStorePickerContext } from "../../storePicker.context";
import { NoResults } from "./components/noResults/noResults.component";
import { StoreCardContainer } from "./components/storeCard/storeCard.container";

export const StorePickerStores = () => {
    const { stores, loading } = useStorePickerContext();

    const isModal = useIsModal();

    const sectionRef = useRef<HTMLSelectElement>(null);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        sectionRef.current?.scrollTo({ top: 0, behavior: "instant" });
    }, [stores, loading]);

    if (!loading && !isDefined(stores)) return null;

    if (!loading && isEmpty(stores)) return <NoResults />;

    return (
        <section
            ref={sectionRef}
            className={cn("tw:overflow-auto", {
                "tw:min-h-[40dvh]": !isModal,
                "tw:overflow-hidden": loading
            })}
        >
            <ul className={cn("tw:flex tw:flex-col tw:gap-2")}>
                {!loading &&
                    stores?.map((store) => (
                        <StoreCardContainer
                            key={store.code}
                            store={store}
                        />
                    ))}
                {loading &&
                    Array.from({ length: 10 }, (_, i) => i + 1).map((i) => (
                        <StoreCardSkeleton key={i} />
                    ))}
            </ul>
        </section>
    );
};
